module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('multiselect', {
    staticClass: "forum-multiselect",
    attrs: {
      "options": _vm.options,
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-97f92326!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/forum/multiselect.vue
// module id = 2108
// module chunks = 2